import { createRouter, createWebHistory } from "vue-router"
import setting_routes from "@/router/setting"
import gec_routes from "@/router/gec"
import ged_routes from "@/router/ged"

import store from "@/store/index.js";

const main = [
    {
        path: "/login",
        name: "login",
        component: () =>
            import ("../components/account/Login.vue"),
    },
    {
        path: "/",
        name: "home",
        component: () =>
            import ("../views/Home.vue"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/about",
        name: "about",
        component: () =>
            import ("../views/About.vue"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/report",
        name: "reports",
        component: () =>
            import ("@/components/report/report.vue"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/report_gec",
        name: "report_gec",
        component: () =>
            import ("@/components/report/GecReport.vue"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/report_ged",
        name: "report_ged",
        component: () =>
            import ("@/components/report/GedReport.vue"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/help",
        name: "help",
        component: () =>
            import ("../views/Help.vue"),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/profile",
        name: "profile",
        component: () => import("../components/account/Profile.vue"),
        meta: {
          requiresAuth: true
        }
    },
];

var all = []

// Concatener tous les routes
const routes = all.concat(main, setting_routes, gec_routes, ged_routes)

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

router.beforeEach((to, from, next) => {

    if (to.path === '/login' && store.state.isAuthenticated) {
        next('/')
        return;
    }

    if (to.matched.some(record => record.meta.requiresAuth) && !store.state.isAuthenticated) {
        next('/login');
        return
    }

    next();
})

export default router;